<script>
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Forgot Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      email: "",
      submitted: false,
      error: '',
      success: false,
      loader: false,
      successMessage: 'An email has been sent to your account to reset password.',
      tryingToReset: false,
      isResetError: false,
      snackbar: false,
      rules: {
        email: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid.',
        ],
      }
    };
  },
  computed:{
    checkLoader(){
      return this.loader
    }
  },
  methods: {
    ...authMethods,
    tryToReset() {
      if (this.validate()) {
          this.loader = true;
        this.submitted = true;
        this.error = '';

        this.tryingToReset = true;
        this.forgotPassword({email: this.email})
            .then(() => {
              this.reset();
              this.resetValidation();
              this.tryingToReset = false;
              this.isResetError = false;
              this.success = true;
              this.email = '';
              this.error = '';
               this.loader = false;
            })
            .catch(err => {
              this.success = false;
              this.error = 'Error! try again later';
              if ('response' in err) {
                if (err.response.status === 422) {
                  this.error = '';
                  const errors = err.response.data;
                  Object.values(errors).forEach(validations => {
                    validations.forEach(validation => {
                      this.error += `${validation}<br>`;
                    })
                  })
                } else if (err.response.status !== 500
                    || ('data' in err.response.data && 'message' in err.response.data.data)
                ) {
                  this.error = err.response.data.data.message;
                }
              }
              this.isResetError = true;
            })
            .finally(() => {
               this.loader = false;
              this.snackbar = true})
      }
    },
    validate () {
      return this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
  },
};
</script>

<template>
  <div class="navy fill-height" id="forgotPassword">
    <v-container :class="$vuetify.breakpoint.mobile ? 'fill-height' : ''">
      <v-row class="d-flex flex-row justify-center" :class="$vuetify.breakpoint.mobile ? 'align-center' : ''">
        <v-col sm="12" md="4">
          <v-card class="pa-5">
            <v-card-title>
              <img src="@/assets/images/logo-dark.png" alt="WesStore" width="100%">
            </v-card-title>
            <v-card class="mb-3 message pa-3" outlined>
              Please enter your username or email address. You will receive an email message with instructions on how to reset your password.
            </v-card>
            <v-form ref="form" @submit.prevent="tryToReset" lazy-validation>
              <v-container  class="text-center"> 
                <v-text-field v-model="email" type="text" label="Email" required
                              :rules="rules.email" outlined dense></v-text-field>
                              <v-progress-circular
                        v-if="checkLoader"
                        :size="30"
                        color="secondary"
                        indeterminate
                       
                      ></v-progress-circular>
                      <v-btn v-else type="submit" color="pink_secondary" block large >
                  <span class="text-transform-none font-weight-bold white--text"  >Get new password</span>
                </v-btn>
                
              </v-container>
            </v-form>
            <v-row class="d-flex flex-column justify-center align-center text-center">
              <v-col><router-link :to="{ name: 'login' }" class="grey--text text--darken-4">Login</router-link> | <router-link :to="{ name: 'Register' }" class="grey--text text--darken-4">Register</router-link></v-col>
              <v-col>
                <router-link to="/" class="grey--text text--darken-4">
                  <v-icon x-small>mdi-arrow-left</v-icon> Go to WeStore
                </router-link>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
        :color="isResetError ? 'red accent-2': 'green'"
        elavation="24"
        top
        right
        v-model="snackbar"
    >
      <div v-html="isResetError ? error : successMessage"></div>
    </v-snackbar>
  </div>
</template>

<style lang="scss" scoped>
.v-card.message {
  border-left: 4px solid #d81b60;
}

.v-card__title {
  margin-bottom: 100px;
}

.v-card {
  .text-transform-none {
    text-transform: none;
  }
}


.v-footer
{
  display: none !important;
}
</style>
